import { render, staticRenderFns } from "./ModalDeleteProduct.vue?vue&type=template&id=2b30f845"
import script from "./ModalDeleteProduct.vue?vue&type=script&lang=js"
export * from "./ModalDeleteProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports